export function calcTwoStep(value) {
  if (value >= 1.1 && value < 1.3) {
    return 1;
  }

  if (value >= 0.9 && value < 1.1) {
    return 2;
  }

  if (value >= 0 && value < 0.9) {
    return 3;
  }

  return null;
}
